import { AdoptersClient } from '../interactors/clients/AdoptersClient'
import { AdopterDto, AdoptionAttemptDtoStatus } from '../interactors/gen/backendClient'

interface Params {
  adopters: AdopterDto[]
  currentAdopterId: string
  animalId: string
}

export const suspendConflictingAdoptionAttempts = async ({ adopters, currentAdopterId, animalId }: Params) => {
  const updates = adopters.flatMap((adopter) => {
    if (adopter.id === currentAdopterId) return []

    return (
      adopter.adoptionAttempts
        ?.filter(
          (attempt) =>
            attempt.animalId === animalId &&
            attempt.status !== AdoptionAttemptDtoStatus.SuspendedByCustomer &&
            attempt.status !== AdoptionAttemptDtoStatus.SuspendedByUser
        )
        .map(async (attempt) => {
          attempt.status = AdoptionAttemptDtoStatus.SuspendedByCustomer
          attempt.done = false
          attempt.archived = false
          await AdoptersClient.updateAdoptionAttempt(adopter.id, attempt)
        }) ?? []
    )
  })

  await Promise.all(updates)
}
